export enum RegistrationStatus {
  SUBMITTED = 1,
  PENDING = 2,
  APPROVED = 3,
  APPROVED_WITH_CONDITIONS = 4,
  CANCELLED = 5,
}
